import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

function login(params: { email: string; password: string }) {
    const baseUrl = '/login-super-user/';
    const headers = config.ADMIN_TOKEN ? { Authorization: `Token ${config.ADMIN_TOKEN}` } : undefined;
    return api.create(baseUrl, params, headers);
}

function logout() {
    const baseUrl = '/logout/';
    return api.create(`${baseUrl}`, {});
}

function signup(params: { fullname: string; email: string; password: string }) {
    const baseUrl = '/register/';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(params: { email: string }) {
    const baseUrl = '/usuario/esqueci-senha/';
    const headers = config.ADMIN_TOKEN ? { Authorization: `Token ${config.ADMIN_TOKEN}` } : undefined;
    return api.create(`${baseUrl}`, params, headers);
}

function forgotPasswordConfirm(params: { email: string }) {
    const baseUrl = '/password/reset/confirm/';
    return api.create(`${baseUrl}`, params);
}

export { login, logout, signup, forgotPassword, forgotPasswordConfirm };
